'use client';

import { type MouseEventHandler } from 'react';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { ChangeIcon } from '@/icons';
import { Button, IconButton } from '@/ui_v3';
export const SettingChangeButton = ({
  onClick
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    isMobile
  } = useViewport();
  if (isMobile) {
    return <IconButton variant="outlined" intent="alternative" size="xs" onClick={onClick} className="shrink-0">
        <ChangeIcon size="xs" />
      </IconButton>;
  }
  return <Button variant="outlined" intent="alternative" size="xs" leftSlot={<ChangeIcon size="xs" />} onClick={onClick} className="shrink-0" data-sentry-element="Button" data-sentry-component="SettingChangeButton" data-sentry-source-file="SettingChangeButton.tsx">
      {t('build:sectionAiTutor.changeButton')}
    </Button>;
};